import { useEffect, useRef } from "react";
import { getSocket } from "../api/socketClient";

/**
 * Subscribe to automated timetable live events.
 * Server emits to room school:${schoolId} (joined on connect):
 *   timetable:ongoing  { schoolId, data, at }
 *   timetable:vacant   { schoolId, data, at }
 *
 * @param {object} opts
 * @param {boolean} opts.isPortal
 * @param {(rows: any[]) => void} [opts.onOngoing]
 * @param {(rows: any[]) => void} [opts.onVacant]
 * @param {boolean} [opts.enabled=true]
 */
export function useTimetableLive({
  isPortal = false,
  onOngoing,
  onVacant,
  enabled = true,
} = {}) {
  const onOngoingRef = useRef(onOngoing);
  const onVacantRef = useRef(onVacant);
  onOngoingRef.current = onOngoing;
  onVacantRef.current = onVacant;

  useEffect(() => {
    if (!enabled) return undefined;

    const userType = isPortal ? "staff" : "owner";
    const socket = getSocket(userType);

    const handleOngoing = (payload) => {
      const list = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload)
          ? payload
          : [];
      onOngoingRef.current?.(list, payload);
    };

    const handleVacant = (payload) => {
      const list = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload)
          ? payload
          : [];
      onVacantRef.current?.(list, payload);
    };

    socket.on("timetable:ongoing", handleOngoing);
    socket.on("timetable:vacant", handleVacant);

    return () => {
      socket.off("timetable:ongoing", handleOngoing);
      socket.off("timetable:vacant", handleVacant);
    };
  }, [isPortal, enabled]);
}

export default useTimetableLive;
 